import gql from 'graphql-tag';

const GENERATE_CATALOG = gql`
  mutation generateCatalog($catalogSpecId: String!, $pricesheetId: String!) {
    generateCatalog(catalogSpecId: $catalogSpecId, pricesheetId: $pricesheetId) {
      catalogSpecLabel,
      pricesheetLabel,
      generatedUrl,
      generatedOn,
    }
  }
`;

export default GENERATE_CATALOG;
